import { ImgHTMLAttributes } from 'react';
import { useTheme } from 'styled-components';

interface ImgThemedProps extends ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    srcDark?: string;
}

const ImgThemed = ({ src, srcDark, ...rest }: ImgThemedProps) => {
    const theme = useTheme();
    const resolvedSrc = theme.mode === 'dark' && srcDark ? srcDark : src;
    return <img src={resolvedSrc} {...rest} />;
};

export default ImgThemed;
